module.exports = __webpack_public_path__ + "static/media/explorador_o.1b136745.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/explorador_o.png
// module id = 1175
// module chunks = 0